import React, { useEffect, useState } from 'react';
import { Phone, X, MessageCircle } from 'lucide-react';
export function FloatingMobileCTA() {
  const [isVisible, setIsVisible] = useState(true);
  const [hasScrolled, setHasScrolled] = useState(false);
  useEffect(() => {
    const handleScroll = () => {
      setHasScrolled(window.scrollY > 300);
    };
    window.addEventListener('scroll', handleScroll);
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);
  if (!isVisible || !hasScrolled) return null;
  return <div className="fixed bottom-0 left-0 right-0 z-50 md:hidden bg-white border-t border-gray-200 shadow-[0_-4px_6px_-1px_rgba(0,0,0,0.1)] pb-safe" data-id="element-103">
      <div className="relative px-3 py-3 flex gap-3" data-id="element-104">
        <button onClick={() => setIsVisible(false)} className="absolute -top-10 right-2 bg-white rounded-full p-1.5 shadow-md border border-gray-100 text-gray-500 hover:text-navy" aria-label="Close" data-id="element-105">
          <X className="w-4 h-4" data-id="element-106" />
        </button>

        <a href="tel:0418381988" className="flex-1 bg-accent text-white py-3 px-2 rounded-xl font-extrabold flex items-center justify-center gap-2 active:bg-accent-600 transition-colors text-sm shadow-md" data-id="element-107">
          <Phone className="w-5 h-5" data-id="element-108" />
          Call Now
        </a>

        <a href="sms:0418381988" className="flex-1 bg-[#25D366] text-white py-3 px-2 rounded-xl font-extrabold flex items-center justify-center gap-2 active:bg-[#20bd5a] transition-colors text-sm shadow-md" data-id="element-109">
          <MessageCircle className="w-5 h-5" data-id="element-110" />
          Text Us
        </a>
      </div>
    </div>;
}